import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { getstandingOrderDays, onTimeChange } from 'src/app/utils/utils.common';
import { ViewChild } from '@angular/core';
import { TripService } from 'src/app/services/core/distributions/trip/trip.service';
import { ActivatedRoute, Router } from '@angular/router';
import { sweetAlert } from 'src/app/utils/swal';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CreateTripComponent } from '../../create-trip/create-trip.component';
@UntilDestroy()

@Component({
  selector: 'app-standing-order-trip-wrapper',
  templateUrl: './standing-order-trip-wrapper.component.html',
  styleUrls: ['./standing-order-trip-wrapper.component.css']
})
export class StandingOrderTripWrapperComponent implements OnInit {
  @ViewChild(CreateTripComponent) createTripComponent!: CreateTripComponent;
  isStandingOrder: any = true;
  submitted = false;
  selectedDay: any = [];
  standingOrderForm!: FormGroup;
  days = getstandingOrderDays
  standingOrderId: any;

  constructor(
    private fb: FormBuilder,
    private tripService: TripService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) { }
  get form() {
    return this.standingOrderForm.controls
  }
  ngOnInit(): void {
    this.days = getstandingOrderDays.map(d => ({ ...d }));
    this.activatedRoute.params.pipe(untilDestroyed(this)).subscribe((param) => {
      if (param && param['standingOrderId'])
        this.standingOrderId = param['standingOrderId']
    })
    this.standingOrderForm = this.createForm();
    // if(this.standingOrderId){
    //   this.getStandingOrderDetails();
    // }

  }

  getStandingOrderDetails() {
    this.tripService.getStandingorderById(this.standingOrderId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.createTripComponent.onSelectSpaceType(data.spaceType);
        this.createTripComponent.newTripForm.patchValue({ ...data, member: data.member.id }); 
        this.createTripComponent.addAttachment(data.attachments);
        this.standingOrderForm.patchValue({
          repeat: data.repeat,
          startDate: data.startDate,
          endDate: data.endDate,
          isActive: data.isActive
        });
        this.createTripComponent.addAddonsItem(data.addons);
        if (data.repeat && Array.isArray(data.repeat)) {
          this.selectedDay = [...data.repeat];
          this.days = getstandingOrderDays.map(day => ({
            ...day,
            checked: this.selectedDay.includes(day.label)
          }));
          this.standingOrderForm.patchValue({
            repeat: this.selectedDay
          });
        }
        this.createTripComponent.memberSearch(null, data.member.id);
      }
      this.isStandingOrder = data.isActive;
    });
  }

  onTripDataLoaded() {
    if (this.standingOrderId) {
      this.getStandingOrderDetails();
    }
  }

  onSelectStatus(evt: any) {
    const value = evt.target.value
    this.isStandingOrder = value === 'true';
  }

  onDateChange(controlName: AbstractControl<any, any> | null) {
    onTimeChange(controlName)
  }

  onDaySelection(day: any) {

    day.checked = !day.checked;

    const index = this.selectedDay.indexOf(day.label);
    if (index === -1) {
      this.selectedDay.push(day.label);
    } else {
      this.selectedDay.splice(index, 1);
    }

    this.standingOrderForm.patchValue({
      repeat: this.selectedDay
        .slice()
        .sort((a: string, b: string) => {
          const dayA = this.days.find(d => d.label === a)?.day ?? 0;
          const dayB = this.days.find(d => d.label === b)?.day ?? 0;
          return dayA - dayB;
        })
    });
    this.standingOrderForm.get('repeat')
  }

  createForm(): FormGroup {
    return this.fb.group({
      repeat: ['', Validators.required],
      startDate: [moment().toISOString(), Validators.required],
      endDate: [moment().add(7, 'days').toISOString(), Validators.required],
      isActive: [true, Validators.required],
    })
  }


  createStandingOrder() {
    this.submitted = true;
    this.createTripComponent.submitted = true;
    if (this.standingOrderForm.invalid || this.createTripComponent.newTripForm.invalid) {
      return;
    }
    const payload = {
      ...this.createTripComponent.newTripForm.value,
      ...this.standingOrderForm.value
    }
    if (payload.pickup.phoneNumber === '') {
      delete payload.pickup.phoneNumber
    }
    if (payload.destination.phoneNumber === '') {
      delete payload.destination.phoneNumber
    }
    if (payload.serviceArea === '') {
      delete payload.serviceArea
    }
    if (payload.legs && Array.isArray(payload.legs)) {
      payload.legs.forEach((leg: any) => {
        if (!leg.pickup.phoneNumber) delete leg.pickup.phoneNumber;
        if (!leg.destination.phoneNumber) delete leg.destination.phoneNumber;
        if (!leg.serviceArea) delete leg.serviceArea;
      });
    }
    this.tripService.createStandingOrderTrip(payload, this.standingOrderId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (data) {
        this.selectedDay = [];
        this.days = getstandingOrderDays.map(d => ({ ...d }));
        this.router.navigateByUrl('/trips/standing-order');
      }
    }, (err) => {
      sweetAlert("Error", err, "error", "OK");

    })

  }
}
